var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from "@opala-ds/react";
import { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import RegisterProof from "../../components/RegisterProof";
import RegistrationProofNotFound from "../../components/RegistrationProofNotFound";
import { useSearchRegistration } from "../../queries/jepis";
import useSearchStore from "../../stores/searchStore";
export default function RegistrationProof() {
    var history = useHistory();
    var codigoInep = useSearchStore(function (state) { return state.codigoInep; });
    var codigoInscricao = useSearchStore(function (state) { return state.codigoInscricao; });
    var cpf = useSearchStore(function (state) { return state.cpf; });
    var dataNascimento = useSearchStore(function (state) { return state.dataNascimento; });
    var tipoInscricao = useSearchStore(function (state) { return state.tipoInscricao; });
    var resetSearch = useSearchStore(function (state) { return state.resetSearch; });
    var hasAnyFilter = useSearchStore(function (state) { return state.hasAnyFilter; });
    useEffect(function () {
        if (!hasAnyFilter()) {
            history.replace("/");
        }
    }, [hasAnyFilter, history]);
    var headerSubtitle = useMemo(function () {
        if (!tipoInscricao)
            return "";
        var map = {
            COACH: "Inscrição Dirigente e/ou Professor (Técnico)",
            SCHOOL_INDIVIDUAL_REGISTRATION: "Inscrição Escola Modalidade Individual",
            SCHOOL_TEAM_REGISTRATION: "Inscrição Escola Modalidade Coletiva",
            STUDENT_ATHLETE: "Inscrição Estudante-atleta",
        };
        return map[tipoInscricao];
    }, [tipoInscricao]);
    var _a = useSearchRegistration({
        codigoInep: codigoInep,
        codigoInscricao: codigoInscricao,
        cpf: cpf,
        dataNascimento: dataNascimento,
    }), data = _a.data, isLoading = _a.isLoading;
    if (isLoading)
        return (_jsx("div", __assign({ className: "container px-6 xl:px-24 space-y-9 flex items-center justify-center" }, { children: _jsx(Icon, { color: "#034ea2", name: "LoaderCircle", className: "size-12 animate-spin" }) })));
    if (!(data === null || data === void 0 ? void 0 : data[0]))
        return _jsx(RegistrationProofNotFound, {});
    return (_jsxs("div", __assign({ className: "container px-6 xl:px-24 space-y-9" }, { children: [_jsx(Header, { title: "Jogos Escolares Piauienses 2025", subtitle: headerSubtitle }), _jsx("div", __assign({ className: "w-full flex items-center justify-center px-0 md:px-12 lg:px-24" }, { children: _jsx(RegisterProof, { data: data[0], type: data[0].tipo }) })), _jsxs("div", __assign({ className: "flex flex-col md:flex-row md:justify-between py-5 space-y-6 md:space-y-0" }, { children: [_jsx(Button, __assign({ type: "button", className: "w-full md:w-max px-6", variant: "outline", onClick: function () {
                            history.replace("/");
                            resetSearch();
                        } }, { children: "Fazer outra inscri\u00E7\u00E3o" })), _jsx(Button, __assign({ type: "button", rightIcon: "SquareArrowOutUpRight", className: "w-full md:w-max px-6", onClick: function () { return window.open(process.env.JEPI_SITE_URL, "_blank"); } }, { children: "Ir para site do JEPI\u2019s" }))] }))] })));
}
